import * as p from '@clack/prompts'
import { readFileSync } from 'node:fs'
import { runDefaultAction } from '@core-engine/commands/default-action/run-default-action.js'
import { requireInitializedProject } from '@core-engine/commands/require-init.js'
import { createAddCommand } from '@core-engine/commands/runtime/create-add-command.js'
import { createAddFieldCommand } from '@core-engine/commands/runtime/create-add-field-command.js'
import { createCreateCommand } from '@core-engine/commands/runtime/create-create-command.js'
import { createGenerateCommand } from '@core-engine/commands/runtime/create-generate-command.js'
import { createInitCommand } from '@core-engine/commands/runtime/create-init-command.js'
import { createListIntegrationsCommand } from '@core-engine/commands/runtime/create-list-integrations-command.js'
import { createListPresetsCommand } from '@core-engine/commands/runtime/create-list-presets-command.js'
import { createRemoveCommand } from '@core-engine/commands/runtime/create-remove-command.js'
import { createRemoveSchemaCommand } from '@core-engine/commands/runtime/create-remove-schema-command.js'
import { createSeedCommand } from '@core-engine/commands/runtime/create-seed-command.js'
import { createUninstallCommand } from '@core-engine/commands/runtime/create-uninstall-command.js'
import { createUpdateCommand } from '@core-engine/commands/runtime/create-update-command.js'
import { createUpdateDepsCommand } from '@core-engine/commands/runtime/create-update-deps-command.js'
import { createUpdateStylesCommand } from '@core-engine/commands/runtime/create-update-styles-command.js'
import { nextCommandRuntime } from '@next-adapter/commands-runtime.js'
import { Command } from 'commander'
import pc from 'picocolors'

const { version } = JSON.parse(
  readFileSync(new URL('../package.json', import.meta.url), 'utf-8')
) as { version: string }

const program = new Command()

program
  .name('betterstart')
  .description('A production ready dashboard, tailored for you in 5 Minutes.')
  .version(version)

program.hook('preAction', (_command, actionCommand) => {
  requireInitializedProject(actionCommand)
})

program.addCommand(createAddCommand(nextCommandRuntime))
program.addCommand(createAddFieldCommand(nextCommandRuntime))
program.addCommand(createCreateCommand(nextCommandRuntime))
program.addCommand(createInitCommand(nextCommandRuntime))
program.addCommand(createListIntegrationsCommand(nextCommandRuntime))
program.addCommand(createListPresetsCommand(nextCommandRuntime))
program.addCommand(createGenerateCommand(nextCommandRuntime))
program.addCommand(createRemoveCommand(nextCommandRuntime))
program.addCommand(createRemoveSchemaCommand(nextCommandRuntime))
program.addCommand(createSeedCommand(nextCommandRuntime))
program.addCommand(createUninstallCommand(nextCommandRuntime))
program.addCommand(createUpdateCommand(nextCommandRuntime))
program.addCommand(createUpdateDepsCommand(nextCommandRuntime))
program.addCommand(createUpdateStylesCommand(nextCommandRuntime))

try {
  if (process.argv.slice(2).length === 0) {
    await runDefaultAction(program, nextCommandRuntime)
  } else {
    await program.parseAsync()
  }
} catch (error) {
  if (process.env.BETTERSTART_DEBUG) {
    console.error(error)
  } else {
    const message = error instanceof Error && error.message ? error.message : String(error)
    p.log.error(message)
    p.log.message(pc.dim('Re-run with BETTERSTART_DEBUG=1 for the full stack trace.'))
  }
  process.exit(1)
}
